/**
 * SalesDataBadge — ehrlicher Verkaufsdaten-Stand (P2a, User-Entscheid §7.5c/3:
 * Features vor Datenreparatur ⇒ der Badge ist Pflicht, das System täuscht
 * keine Frische vor).
 */
import { useTranslation } from 'react-i18next'

import type { ProductWithIssues } from '@/lib/api/channel-readiness'

export function SalesDataBadge({ products }: { products: ProductWithIssues[] }) {
  const { t } = useTranslation()
  const withData = products.filter((p) => p.revenue_30d != null)
  const latest = products.reduce<string | null>(
    (max, p) => (p.last_sale_date && (!max || p.last_sale_date > max) ? p.last_sale_date : max),
    null,
  )
  if (!latest) {
    return <span className="text-xs text-neutral-500" data-testid="sales-data-badge">{t('productsIssues.salesBadge.none')}</span>
  }
  const date = new Date(latest).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
  return (
    <span className="rounded-full border border-neutral-300 px-2.5 py-0.5 text-xs text-neutral-500 dark:border-neutral-700" data-testid="sales-data-badge">
      {t('productsIssues.salesBadge.status', { date })} · {withData.length} / {products.length}
    </span>
  )
}
